import React, { Component } from 'react';
import styled from 'styled-components/macro';
import scaleSize from '../utils/scale-size';
import moment from 'moment';
import PropTypes from 'prop-types';
import { INIT_UI_LANGUAGE } from 'constants/languages';
import config from 'config';

const ClockWrapper = styled.div`
  height: ${scaleSize(80)}px;
  box-sizing: border-box;
  padding: 0 ${scaleSize(40)}px;
  border-radius: ${scaleSize(40)}px;
  background-color: ${({ theme, type }) =>
    type === 'EPG' ? theme.playerClockBg : theme.imagePlaceholder};
  font-family: 'RobotoRegular', sans-serif;
  font-size: ${scaleSize(34)}px;
  line-height: ${scaleSize(80)}px;
  font-weight: bold;
  font-stretch: condensed;
  font-style: normal;
  letter-spacing: normal;
  text-align: center;
  position: absolute;
  z-index: 10;
  top: ${({ type }) => (type === 'EPG' ? scaleSize(595) : scaleSize(60))}px;
  right: ${({ type }) => (type === 'EPG' ? `${scaleSize(55)}px` : `${scaleSize(80)}px`)};
  color: ${({ theme, type }) => (type === 'EPG' ? theme.defaultColor : theme.mainTextColor)};
  margin-top: ${(props) => scaleSize(props.hide ? -300 : 0)}px;
  transition: ${({ noAnimation }) => (!noAnimation ? `margin-top ease-out 0.3s` : 'none')};
`;

const ONE_MINUTE = 1000 * 60;

class Clock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      time: moment().add(config.timeDiffFromServer, 'm'),
    };
  }
  componentDidMount() {
    this.intervalID = setInterval(() => this.tick(), ONE_MINUTE);
  }
  componentWillUnmount() {
    clearInterval(this.intervalID);
  }
  tick() {
    this.setState({
      time: moment().add(config.timeDiffFromServer, 'm'),
    });
  }
  render() {
    const { type } = this.props;
    const formatStringTemplate = type === 'EPG' ? 'HH:mm' : 'D MMM, HH:mm';
    return (
      <ClockWrapper {...this.props}>
        {this.state.time.locale(INIT_UI_LANGUAGE).format(formatStringTemplate)}
      </ClockWrapper>
    );
  }
}

Clock.propTypes = {
  hide: PropTypes.bool,
};

export default Clock;
